import { createContext, useContext } from 'react';
import type { ProfileRow } from '../data/db';

export interface ProfilesValue {
  /** Только живые профили, в порядке появления. Надгробия сюда не
   *  попадают: их видит одна отправка в фазе 3. */
  profiles: ProfileRow[];
  active: ProfileRow;
  /** Перечитать профили из базы. Зовётся после заведения, смены облика,
   *  переключения и удаления — то есть после всего, что меняет список. */
  refresh: () => Promise<void>;
}

const ProfilesContext = createContext<ProfilesValue | null>(null);

export const ProfilesProvider = ProfilesContext.Provider;

export function useProfiles(): ProfilesValue {
  const value = useContext(ProfilesContext);
  /** Отказ, а не заглушка. Экран профилей вне шлюза означал бы список,
   *  который никогда не обновляется, и переключение, которое ничего не
   *  переключает, — то есть поломку, видимую только глазами. */
  if (!value) throw new Error('экран профилей вне ProfileGate');
  return value;
}
